import React from 'react';
import { Layout } from 'react-admin';
import AppBar from './AppBar';
const CustomLayout = (props) => (React.createElement(Layout, Object.assign({ appBar: AppBar }, props)));
export default CustomLayout;
//# sourceMappingURL=Layout.js.map